export enum EntityType {
  ActivityPhaseScheduleBar = 'ActivityPhaseScheduleBar',
  ActivityPhaseScheduleBarGroup = 'ActivityPhaseScheduleBarGroup',
  ActivityPhaseScheduleBarRequest = 'ActivityPhaseScheduleBarRequest',
  ScopeRequest = 'ProjectScopeRequest'
}
